<script setup lang="ts">
import { useRoute } from "vue-router";

const route = useRoute();
</script>

<template>
  <section class="tw-mx-auto tw-max-w-xl tw-space-y-4 tw-p-6" aria-label="Summarizer configuration has moved">
    <h2 class="tw-text-xl tw-font-semibold">Summarizer configuration has moved</h2>
    <p>Summarizer configuration and testing are now in Unity Config Web.</p>
    <p>
      To get started, open Unity Config Web, go to Viewer &gt; Summarizer Configuration, then choose your client and
      brand. You can create configurations there and try them out on the Test tab.
    </p>
    <router-link :to="{ name: 'brand', params: { brand: route.params.brand } }"
      class="tw-inline-block tw-text-blue-600 tw-underline tw-underline-offset-2 hover:tw-text-blue-700">
      Back to Case Search
    </router-link>
  </section>
</template>
